import { render, staticRenderFns } from "./CatProduct.vue?vue&type=template&id=3ee3e68a"
import script from "./CatProduct.vue?vue&type=script&lang=js"
export * from "./CatProduct.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./CatProduct.vue?vue&type=style&index=0&id=3ee3e68a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "0f95207a"
  
)

export default component.exports